import { render, staticRenderFns } from "./DisclaimerDialog.vue?vue&type=template&id=36b8dcf6&scoped=true&"
import script from "./DisclaimerDialog.vue?vue&type=script&lang=js&"
export * from "./DisclaimerDialog.vue?vue&type=script&lang=js&"
import style0 from "./DisclaimerDialog.vue?vue&type=style&index=0&id=36b8dcf6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b8dcf6",
  null
  
)

export default component.exports